import React from "react";
import { useLocation } from "react-router-dom";
import { Col } from "~/components/elements";
import { PageLayout } from "~/components/layouts/PageLayout";
import { ConfirmVerificationCode } from "~/pages/forgot-password/ConfirmVerificationCode";

function EmailConfirmation() {
  const location = useLocation<{ userId: string; email: string; timer: number }>();
  const userId = location?.state?.userId;
  const userEmail = location?.state?.email;

  return (
    <PageLayout
      metaTagsConfig={{
        metas: [{ name: "robots", content: "noindex,nofollow" }],
      }}
    >
      <Col alignItems="center">
        <ConfirmVerificationCode
          onSuccess={({ code }) => console.log(code)}
          userId={userId}
          email={userEmail}
          type="register"
        />
      </Col>
    </PageLayout>
  );
}

export default EmailConfirmation;
